import { Spinner } from '@material-tailwind/react/components/Spinner';
import { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { VideoStreamProvider } from 'src/providers/video-stream-provider';
import { useAdminStore } from 'src/stores/useAdminStore';
import { useAuthStore, useCurrentUserStore } from 'src/stores/useUserStore';

const PrivateRouter = lazy(() => import('./private-router'));
const PublicRouter = lazy(() => import('./public-router'));

export function AppRouter() {
  const {
    changeAuthState,
    state: { authToken, isAuthorized },
  } = useAuthStore();
  const { currentUser } = useCurrentUserStore();
  const { removeAdminAuthToken, setAdminAuthToken } = useAdminStore();

  // use case for redirect from farmsort.de
  useEffect(() => {
    const url = new URL(window.location.href);
    const [, authToken] = url.hash.split('authToken=');
    if (authToken) {
      changeAuthState({ authToken });
      // remove token from URL without reloading the page
      window.history.replaceState({}, document.title, '/');
    }
  }, [changeAuthState]);

  useEffect(() => {
    if (currentUser?.role === 'ADMIN' && authToken) {
      setAdminAuthToken(authToken);
    } else {
      removeAdminAuthToken();
    }
  }, [authToken, currentUser, removeAdminAuthToken, setAdminAuthToken]);

  return (
    <BrowserRouter>
      <Suspense
        fallback={
          <div className="flex h-screen w-screen content-center items-center justify-center opacity-50">
            <Spinner className="h-12 w-12" />
          </div>
        }
      >
        <VideoStreamProvider>
          {isAuthorized ? <PrivateRouter /> : <PublicRouter />}
        </VideoStreamProvider>
      </Suspense>
    </BrowserRouter>
  );
}
